import React, { Component } from 'react'
import { formatCurrency } from '../../../../utils/currency'
import './line.scss'

// Elements
import Grid from '../../../elements/grid'
import Icon from '../../../elements/icon'
import RemoveButton from '../../../elements/removeButton'
import { ElementIcons } from '../../../elements/icons'
// import Expand from '../../../elements/expand'

/**
 * General line rendering component for extent.
 * 'Text' and 'Amount' can both be simple values, or functions.
 * When 'CanExpand' is true, the line will be rendered with an arrow to allow expanding children.
 * When 'CanExpand' is false, children will always be rendered.
 */
class Line extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }

  render () {
    const canDelete = () => {
      if (!(this.props.onDelete === undefined || this.props.onDelete === null) && typeof this.props.onDelete === 'function') return true
      return false
    }
    const renderDelete = () => {
      if (canDelete()) {
        return (
          <span className='delete'>
            <RemoveButton size='s' minus onClick={this.props.onDelete} />
          </span>
        )
      }
    }

    const renderText = () => {
      if (this.props.text === undefined || this.props.text === null) return <div className='text' />
      if (typeof this.props.text === 'function') {
        return this.props.text()
      }
      let css = ''

      if (this.props.bold || this.props.boldText) css += ' bold'
      if (this.props.subLine) {
        css += ' subLine'
      }
      return <div className={'text' + css}>{this.props.text}</div>
    }

    const renderAmount = () => {
      if (this.props.amount === undefined || this.props.amount === null) return null
      if (typeof this.props.amount === 'function') {
        return this.props.amount()
      }
      let css = ''
      if (this.props.bold || this.props.boldAmount) css += ' bold'
      if (this.props.isTotal) css += ' total'
      if (this.props.isBlue) css += ' blue'

      // If CanExpand is true, render with arrow that allows expanding props.children
      // (when CanExpand is true, the main amount is always rendered as non-editable)
      if (this.props.canExpand) {
        let arrowClass = this.state.open ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
        css += this.state.open ? ' canOpen isOpen' : ' canOpen'
        let amount = (this.state.open && this.props.amountOpen !== undefined) ? this.props.amountOpen : this.props.amount
        return (
          <div className={'amount' + css}>
            <i className={arrowClass} onClick={() => {
              this.setState({open: !this.state.open}, () => {
                if (this.props.onOpenChange !== undefined) {
                  this.props.onOpenChange(this.props.name, this.state.open)
                }
              })
            }} />
            <span>{(amount === '' || amount === null) ? '' : formatCurrency(amount, 2)}</span>
          </div>
        )
      }

      let amount = this.props.noFormat ? this.props.amount : formatCurrency(this.props.amount)
      if (amount === 'NaN') amount = ''
      return <div className={'amount' + css}><div>{amount} {this.props.currencyType && this.props.currencyType}</div></div>
    }

    let css = ' '
    let subCss = ''
    if (this.props.spacing === true) css += 'spacing'
    if (this.props.className !== undefined) css += ' ' + this.props.className
    // if (this.props.isVat) css += ' borderbuttom'   // Line component should not be specialized to this level
    if (canDelete()) subCss += ' indent'
    let cols = null
    if (this.props.subLine) {
      cols = ['min-content', 1, 'min-content']
    } else {
      cols = [1, 'min-content']
    }
    return (
      <div key={this.props.renderKey} className={'extent-line clearfix' + css}>
        {renderDelete()}
        <Grid cols={cols} align='center'>
          {this.props.subLine && <Icon icon={ElementIcons.Indent} size='t' injectSvg />}
          {renderText()}
          {this.props.hideAmount || renderAmount()}
        </Grid>
        {this.props.children !== undefined && this.props.children !== null && (!this.props.canExpand || this.state.open) && (
          <div className={'sublines clearfix' + subCss}>
            {this.props.children}
          </div>
        )}
      </div>
    )
  }
}

export default Line



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Line/index.js